import React from 'react';
import {
  faHouseUser,
  faHandsWash,
  faPeopleArrows,
  faUserMd,
  faHeadSideMask
} from '@fortawesome/free-solid-svg-icons';
import HealthCard from './HealthCard';

function HealthTips() {
  return (
    <>
      {tips.map((tip, index) => (
        <HealthCard
          key={`${tip.name}-tip-${index}`}
          name={tip.name}
          icon={tip.icon}
          content={tip.caption}
          size="4x"
        />
      ))}
    </>
  );
}

const tips = [
  {
    name: 'Social Distance',
    icon: faPeopleArrows,
    caption: 'At least 6 feet apart'
  },
  {
    name: 'Wash your hands',
    icon: faHandsWash,
    caption: 'In warm water for at least 30 seconds with soap and water'
  },
  {
    name: 'Stay at home',
    icon: faHouseUser,
    caption: 'If you choose to go out, choose an outdoor activity'
  },
  {
    name: 'Wear a mask',
    icon: faHeadSideMask,
    caption: 'Findings have found anything helps!'
  }
];

export default HealthTips;
